import { getAuthorizationCredentials } from './GetAuthorizationCredentials';

export const CredentialsApi = {
  getAuthorizationCredentials,
};
